import React, { useMemo } from 'react';

import Modal from '../../../../design-system/Modal/Modal';
import ModalHeader from '../../../../design-system/ModalHeader/ModalHeader';
import SettingsViewOnlyForm from '../SettingsViewOnlyForm/SettingsViewOnlyForm';

const ViewOnlyNestedItemModal = ({ item, properties, itemName, onClose }) => {
    const data = useMemo(() => {
        if (!properties || !properties?.length || !item) return [];

        return properties.map((property) => ({
            ...property,
            value: item?.[property.name],
        }));
    }, []);

    return (
        <Modal onClose={onClose} size="medium" resetPadding customStyles="overflow-hidden">
            <div className="flex flex-col max-h-[90vh] sm:max-h-[70vh]">
                <ModalHeader
                    onClose={onClose}
                    title={`View ${itemName}`}
                    customPaddings="px-5 py-3"
                    outlined
                />

                <div className="p-5 overflow-y-auto">
                    <SettingsViewOnlyForm settings={data} />
                </div>
            </div>
        </Modal>
    );
};

export default ViewOnlyNestedItemModal;
